var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isIos || _vm.isAndroid)?_c('div',[_c('UpgradeDevice')],1):_c('div',[_c('UpgradeComp')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }